import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'

import * as userManagerStore from '@/store/userManager'

export {
  userManagerStore
}

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createUserManagerMixin = (without = []) => {
  const actions = !without.includes('actions') ? mapActions(userManagerStore.moduleName, Object.keys(userManagerStore.actionTypes)) : {}
  const getters = !without.includes('getters') ? mapGetters(userManagerStore.moduleName, Object.keys(userManagerStore.getterTypes)) : {}
  const mutations = !without.includes('mutations') ? mapMutations(userManagerStore.moduleName, Object.keys(userManagerStore.mutationTypes)) : {}

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  }
}
